import 'leaflet/dist/leaflet.css';

if (import.meta.env.DEV) {
  // Load SCSS only in dev so Vite HMR tracks style changes without bundling CSS in prod.
  await import("../scss/style.scss");
}

const menu = document.querySelector<HTMLDetailsElement>(".menu-mobile");
if (menu) {
  const links = menu.querySelectorAll<HTMLAnchorElement>("a[href]");
  links.forEach((link) => {
    link.addEventListener("click", () => {
      menu.removeAttribute("open");
    });
  });
}

const header = document.querySelector<HTMLElement>(".site-header");
const hero = document.querySelector<HTMLElement>("#hero");
const isDesktop = window.matchMedia("(min-width: 576px)").matches;

if (header && hero && isDesktop && "IntersectionObserver" in window) {
  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        header.classList.remove("site-header--scrolled");
      } else {
        header.classList.add("site-header--scrolled");
      }
    },
    {
      root: null,
      threshold: 0,
    },
  );

  observer.observe(hero);
}
